"use client";
import React from "react";
import { useRateContext } from "@/src/provider";
import useMounted from "../hooks/useMounted";
interface IProps {
    price: number | string;
}
const GetPriceClient: React.FC<IProps> = (props) => {
    const getPrice = useRateContext((s) => s.getPrice);
    const mounted = useMounted();
    return mounted && getPrice(props.price);
};
export default GetPriceClient;
